/* @flow */
import EventTracking from 'lib/EventTracking';
import ToastActions from 'actions/ToastActions';
import LocalUserSettings from 'lib/LocalUserSettings';

const WebNotificationActions = {
  updateLocalUserEnabled(enabled: boolean) {
    const properties = LocalUserSettings.getUserProperties();
    properties.settings.displayWebNotifications = enabled;
    LocalUserSettings.updateUser(properties);
  },

  askForPermission() {
    return new Promise(resolve => {
      window.Notification.requestPermission((permission) => {
        if (permission === 'granted') {
          ToastActions.showSuccessToast('Desktop notifications turned on');
          EventTracking.view('desktop_notification_success_toast');
          this.updateLocalUserEnabled(true);
        } else if (permission === 'denied') {
          ToastActions.showErrorToast('There was a problem turning on desktop notifications');
          EventTracking.view('desktop_notification_error_toast');
          this.updateLocalUserEnabled(false);
        }
        resolve(permission);
      });
    });
  },
};

export default WebNotificationActions;



// WEBPACK FOOTER //
// ./src/notifications/WebNotificationActions.js